import { trackEvent } from './analytics';

const fired = new Set();
const PURCHASE_KEY = 'hq_ga_purchase_ids';

export const deviceType = () =>
  (typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop');

// Funnel event with the standard (PII-free) payload. Pass onceKey to fire at most once per page load.
export const trackFunnel = (name, { package_name = 'Not selected', booking_value = 0, ...extra } = {}, onceKey) => {
  if (onceKey) {
    if (fired.has(onceKey)) return;
    fired.add(onceKey);
  }
  const value = Number(booking_value) || 0;
  trackEvent(name, {
    service_name: 'Recording Session',
    package_name,
    booking_value: value,
    value,
    currency: 'USD',
    device_type: deviceType(),
    items: [{ item_id: 'recording_session', item_name: 'Recording Session', item_variant: package_name, price: value, quantity: 1 }],
    ...extra,
  });
};

// Fires `purchase` exactly once per transaction id, even across reloads.
export const trackPurchaseOnce = (transactionId, params) => {
  if (!transactionId) return false;
  let ids = [];
  try { ids = JSON.parse(localStorage.getItem(PURCHASE_KEY) || '[]'); } catch { ids = []; }
  if (ids.includes(transactionId)) return false;
  localStorage.setItem(PURCHASE_KEY, JSON.stringify([...ids, transactionId].slice(-25)));
  trackFunnel('purchase', { ...params, transaction_id: transactionId });
  return true;
};

let clickTrackingReady = false;
export const initBookingClickTracking = () => {
  if (clickTrackingReady || typeof document === 'undefined') return;
  clickTrackingReady = true;
  document.addEventListener('click', (e) => {
    const el = e.target.closest && e.target.closest('a[href="/book"], a[href="/book-now"], a[href="#booking"], [data-book-cta]');
    if (!el) return;
    trackFunnel('booking_button_click', { button_location: el.dataset.testid || (el.textContent || '').trim().slice(0, 40) });
  }, true);
};
